<template>
	<div>
		<div v-for="(events, date) in getEvents" class="d-flex mt-3" :key="`events-date-`+date">
			<div class="text-center mr-3">
				<div class="font-size-h2 font-weight-bold text-success">
					{{getDay(date)}}
				</div>
				<div class="font-weight-bold font-size-sm text-secondary">{{getMonth(date)}}</div>
			</div>
			<div class="flex-grow-1">
				<div @click="clickEvent(event)" v-for="(event,k) in events"
					:key="event.uid" class="d-block" :class="{'mt-3': k>0, 'mt-1': k==0}">
					<div class="font-weight-bold text-secondary font-size-sm ">{{event.start | formatTime}}</div>
					<div class="mt-1 rounded border border-secondary border-2 p-2 d-flex">
						<div :style="{'background-color': event.color}" class="p-2 mr-3">&nbsp;</div>
						<div class="flex-grow-1">
							<div class="font-size-h3 font-weight-bold" v-if="event.client.name">
								{{event.client.name}}<template v-if="event.client.addressname"> - {{event.client.addressname}}</template>
							</div>
							<div v-if="event.client.city">
								{{event.client.city}}
							</div>
							<div class="d-flex justify-content-between">
								<div class="font-size-sm">
									<span>{{event.state}}</span>
									<span class="badge badge-pill ml-2" :class="{'badge-danger': getSyncStatus(event.uid)===0, 'badge-success': getSyncStatus(event.uid)===1, 'badge-warning': getSyncStatus(event.uid)===2}">&NoBreak;</span>
								</div>
							</div>
							<div>
								{{event.title}}
							</div>
						</div>
						<div class="align-self-center pl-2 pr-4">
							<i class="fal fa-chevron-right text-secondary"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
import {mapGetters} from 'vuex';
	
	export default {
		name: 'ListEvents',
		computed: {
			// mix the getters into computed with object spread operator
			...mapGetters('events', [
				'getEvents',
			]),
			...mapGetters('interventions', [
				'getSyncStatus',
			]),
			...mapGetters('config', {'getCalendrierId': 'getCalendrierId'}),
		},
		mounted: async function(){
			if (this.getCalendrierId){
				await this.$store.dispatch('events/refresh', this.getCalendrierId)
			}
		},
		methods: {
			clickEvent: function (event) {
                this.$router.push({name: 'event', params: {eventid: event.uid}});
			},
			getDay(date){
				return moment(date).format('D');
			},
			getMonth(date){
				return moment(date).format('MMM');
			}
		}
	};
</script>
